<template>
	<div class="app">
		<div class="app__wrap">
			<SiteHeader></SiteHeader>
			<main>
				<router-view />
			</main>
			<SiteFooter></SiteFooter>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import SiteHeader from "./components/header/SiteHeader.vue";
import SiteFooter from "./components/SiteFooter.vue";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
//Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
//Vue.use(IconsPlugin)

export default Vue.extend({
	name: "APP",
	components: {
		SiteHeader,
		SiteFooter
	}
});
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700&display=swap");

// normalization - style resets
@import "../node_modules/normalize-scss/sass/normalize/import-now";

/*
// Additional style resets
*/

input[type="number"] {
	-moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

table {
	border-collapse: collapse;
	border-spacing: 0;
}

.srt-wrap::-ms-expand {
	display: none;
}

a {
	text-decoration: none;
	color: #000;
}

ul {
	list-style-type: none;
}

abbr {
	text-decoration: none !important;
	cursor: help;
}

* {
	padding: 0;
	margin: 0;
}

/*
// Global styles
*/

h1 {
	line-height: 24px;
	font-size: 18px;
	margin: 0;
}

body {
	font-family: "Montserrat", sans-serif;
	background: $color8;
	max-width: 1400px;
	margin: 0 auto;

	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-rendering: optimizeLegibility;
}

footer {
	padding-bottom: 5px;
}

/*
// To keep footer at bottom.
*/

.app {
	position: relative;
	min-height: 100vh;

	&__wrap {
		padding-bottom: #{30px + 40px + 20px};
	}
}

.table-title {
	text-transform: uppercase;
	border: 1px solid $border-color;
	border-bottom: none;

	border-top-right-radius: 7px;
	border-top-left-radius: 7px;
	background-color: lighten($color7, 10%);

	text-align: center;
	font-weight: 600;
	line-height: 27px;
	margin-top: 40px;
	font-size: 14px;
}

.btn {
	transition: background-color $btn-transition linear;
	box-shadow: 1px 1px 1px $border-color;
	text-decoration: none;
	cursor: pointer;
	color: $color1;
	border: none;

	&--red {
		background-color: $color5;
		&:hover {
			background-color: $text-highlighter !important;
		}
	}

	&--blue {
		background-color: $color2;
		&:hover {
			background-color: $color4L !important;
		}
	}

	&--blue2 {
		background-color: #7b91c0;
		&:hover {
			background-color: $color4 !important;
		}
	}

	&--blue3 {
		background-color: $color4;
		&:hover {
			background-color: $color4L !important;
		}
	}

	&--blue4 {
		background-color: $color3;
		box-shadow: none;

		&:hover {
			background-color: $color4 !important;
		}
	}
}
</style>
